export default "__VITE_ASSET__Bi9$RJj4__"